import { render } from "./modal_Uikit.vue?vue&type=template&id=7d64af5d"
import script from "./modal_Uikit.vue?vue&type=script&lang=js"
export * from "./modal_Uikit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__